import { render } from "./TruckList.vue?vue&type=template&id=04fe268b&scoped=true"
import script from "./TruckList.vue?vue&type=script&lang=js"
export * from "./TruckList.vue?vue&type=script&lang=js"

import "./TruckList.vue?vue&type=style&index=0&id=04fe268b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04fe268b"]])

export default __exports__